export const borderStyles =
  "border-t first:border-t-0 border-x-0 border-b-0 border-solid border-t-gray-100 [&+.location-row]:sm:hover:border-t-transparent";
export const containerSpaceStyles = "flex flex-row justify-between py-3 gap-3 rounded-lg";

export const withTextStyle = (className: string, ifEnabled: string, disabled: boolean) =>
  disabled ? `${className} text-gray-600` : `${className} ${ifEnabled}`;
